













































































































































































import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';
import STextarea from '@/common/components/STextareaShort.vue';
import TableInput from '@/tasks/components/inputs/TableInput.vue';
import FileUploadUiComponent from '@/tasks/components/task-ui-components/FileUploadUiComponent.vue';
import ChemicalNotationInput from '@/chemical-equations/components/ChemicalNotationInput.vue';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'Queens_Lab4_ReportSheet2',
  components: {
    ChemicalLatex,
    ChemicalNotationInput,
    FileUploadUiComponent,
    TableInput,
    STextarea,
    CalculationInput,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        unknownCode: null,

        unknownInitialObs: null,
        unknownInitialInf: null,

        unknownAndKIObs: null,
        unknownAndKIInf: null,

        unknownAndNH3Obs: null,
        unknownAndNH3Inf: null,

        unknownAndNa2CO3Obs: null,
        unknownAndNa2CO3Inf: null,

        unknownAndK2CrO4Obs: null,
        unknownAndK2CrO4Inf: null,

        cationIdentity: null,

        explanation: null,
      },
      cationOptions: [
        {text: 'Chromium(III)', value: 'chromium(III)'},
        {text: 'Cobalt(II)', value: 'cobalt(II)'},
        {text: 'Copper(II)', value: 'copper(II)'},
        {text: 'Iron(III)', value: 'iron(III)'},
        {text: 'Iron(II)', value: 'iron(II)'},
        {text: 'Nickel(II)', value: 'nickel(II)'},
      ],
    };
  },
};
